/**
 * WARNING!! DO NOT MERGE THIS FILE WITH api-exceptions.ts
 * Webpack can't tree-shake our custom error classes. I moved zod-less code here to avoid this.
 */

export const VarietyPropertyName = '__AUDIENZZ_API_CLASS_VARIANT__';
export enum ApiExceptions {
  Error = 'Error',
  Cancel = 'Cancel',
}

export function unsafeMakeApiError(obj: object): unknown {
  return {
    ...obj,
    [VarietyPropertyName]: ApiExceptions.Error,
  };
}
